import { motion } from "framer-motion";
import { scrollToId } from "@/lib/scroll";

const EASE = [0.16, 1, 0.3, 1];

export default function Hero() {
  return (
    <section
      data-testid="hero-section"
      className="relative flex min-h-screen flex-col justify-center border-b border-[#E3EBF3] bg-white px-6 pb-16 pt-24 md:px-12"
    >
      <div className="flex w-full flex-row items-center justify-between gap-5 md:gap-8 lg:gap-10">
      <motion.div
        initial={{ opacity: 0, y: 24 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.9, delay: 0.3, ease: EASE }}
      >
        <span className="inline-flex items-center gap-2 rounded-full border border-[#BBDCF3] bg-[#EFF6FC] px-3 py-2 text-[10px] font-semibold tracking-[0.1em] text-[#1479BF] sm:px-4 sm:text-[11px] sm:tracking-[0.12em]">
          <span
            aria-hidden="true"
            className="h-1.5 w-1.5 rounded-full bg-[#E8A33D]"
          />
          LAMAN INFORMASI PUBLIK
        </span>

        <p
          data-testid="hero-subline"
          className="mt-8 max-w-2xl font-display text-3xl font-semibold leading-tight text-[#0B2440] md:text-5xl"
        >
          Pusat Informasi Publik
        </p>
        <p className="mt-4 text-sm text-slate-500 md:text-base">
          Diktisaintek Berdampak Bagi Indonesia Melalui Keterbukaan Informasi
          Publik
        </p>
        <div className="mt-8 h-1.5 w-20 rounded-full bg-[#E8A33D]" />
        <button
          data-testid="hero-cta-selengkapnya"
          onClick={() => scrollToId("#selamat-datang")}
          className="mt-10 inline-flex items-center gap-3 rounded-full bg-[#1479BF] px-7 py-3.5 text-xs font-bold tracking-[0.08em] text-white transition-colors duration-300 hover:bg-[#0B2440]"
        >
          SELENGKAPNYA
        </button>
      </motion.div>

      <motion.div
        initial={{ opacity: 0, scale: 0.9 }}
        animate={{ opacity: 1, scale: 1 }}
        transition={{ duration: 0.9, delay: 0.5, ease: EASE }}
        className="flex shrink-0 justify-end"
      >
        <motion.img
          src="/diktisaintek-berdampak.webp"
          alt="Logo Diktisaintek Berdampak"
          data-testid="hero-logo-diktisaintek"
          width={640}
          height={640}
          animate={{ y: [0, -12, 0] }}
          transition={{ duration: 6, repeat: Infinity, ease: "easeInOut" }}
          className="h-auto w-28 drop-shadow-[0_28px_56px_rgba(11,36,64,0.16)] sm:w-40 md:w-80 lg:w-96"
        />
      </motion.div>
      </div>
    </section>
  );
}
